import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function CryptoBlockchainLicenseCyprus (){

    return (
        <main className='main'>

            <IntroSection
                title="Crypto & Blockchain License – Cyprus (CySEC CASP)"
                subtitle="Regulated Crypto Business with EU Recognition"
                description =
                    "
                    <b>Cyprus</b> is one of the <b>leading EU hubs</b> for <b>crypto exchanges</b>, <b>wallet providers</b>, <b>custodians</b>, and <b>token projects</b>. The <b>Cyprus Securities and Exchange Commission (CySEC)</b> supervises <b>Crypto Asset Service Providers (CASPs)</b>, requiring <b>registration under the Cyprus AML Law (AMLD5/AMLD6)</b>.
                    With <b>EU credibility</b>, <b>attractive taxation (12.5%)</b>, and <b>strategic location</b>, <b>Cyprus</b> is becoming a <b>preferred choice</b> for <b>crypto exchanges</b> and <b>fintech startups</b>.
                    "
                badges={
                    [
                        "Crypto Exchange",
                        "Wallet & Custody",
                        "Token Issuance",
                        "DeFi & Blockchain Services"
                    ]
                }
                buttonText="Request a Cyprus Crypto Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gibraltar-crypto-dlt-license-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Cyprus for Crypto?'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "EU Credibility",
                                            text: "CASPs are registered with CySEC under EU AML standards."
                                        },
                                        {
                                            title: "MiCA Ready",
                                            text: "CASPs will be among the first recognized under EU-wide MiCA rules."
                                        },
                                        {
                                            title: "Banking & PSP Access",
                                            text: "Easier than offshore jurisdictions."
                                        },
                                        {
                                            title: "Attractive Corporate Tax",
                                            text: "Only 12.5%."
                                        },
                                        {
                                            title: "Crypto-Friendly Hub",
                                            text: "Growing number of fintech & blockchain companies."
                                        }
                                    ]
                            }
                        ]}
                    />


                    <InfoBlocks
                        title="What Can a CASP Do?"
                        subtitle='A Cyprus CASP registration allows you to:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            text: "Run crypto exchanges (spot, OTC, brokerage)."
                                        },
                                        {
                                            text: "Provide custody & wallet services (hot/cold storage)."
                                        },
                                        {
                                            text: "Facilitate crypto-to-fiat & fiat-to-crypto gateways."
                                        },
                                        {
                                            text: "Issue tokens, ICOs, STOs, IEOs under compliance rules."
                                        },
                                        {
                                            text: "Operate DeFi and blockchain-based services."
                                        },
                                        {
                                            text: "Manage NFT marketplaces and Web3 platforms."
                                        }
                                    ]
                            }
                        ]}
                    />


                    <LocationTimeline
                        title="Capital Requirements (CASP Tiers)"
                        subtitle='CySEC applies different minimum capital based on services:'
                        item={
                            [
                                {
                                    title: "€50,000",
                                    text: "Small-scale CASP (advisory, minor services)."
                                },
                                {
                                    title: "€125,000",
                                    text: "Exchange, brokerage services."
                                },
                                {
                                    title: "€150,000–€750,000",
                                    text: "Custody, market-making, large-scale exchanges."
                                }
                            ]
                        }
                    />
                    <ServiceCards
                        title='Benefits of a Cyprus CASP License'
                        services={
                            [
                                {
                                    title: "EU Credibility",
                                    text: "Recognized by regulators, investors, and PSPs."
                                },
                                {
                                    title: "Compliance-Friendly",
                                    text: "Aligned with AMLD5/6 & FATF."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Better chance of onboarding with EU banks & EMIs."
                                },
                                {
                                    title: "Investor Attraction",
                                    text: "Licensed crypto firms raise more capital."
                                },
                                {
                                    title: "MiCA-Ready",
                                    text: "Early CASP registration positions firms for future EU-wide passporting."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Proccess'
                        features={

                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Define business model (exchange, wallet, token, custody)."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Register a Cyprus entity."
                                },
                                {
                                    title: "Application Submission",
                                    text: "AML/KYC manuals, governance, business plan, capital proof."
                                },
                                {
                                    title: "CySEC Review",
                                    text: "Fit & proper test for shareholders, directors, compliance officer."
                                },
                                {
                                    title: "Approval & Registration",
                                    text: "Typically 6–9 months."
                                },
                                {
                                    title: "Operational Setup",
                                    text: "Banking, PSPs, crypto compliance systems."
                                }
                            ]
                        }
                        />
                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6-9 months.",
                            },
                            {
                                name: "Setup Cost",
                                description: "from €70,000+ (legal, compliance, incorporation, advisory).",
                            },
                            {
                                name: "Annual Renewal Fees",
                                description: "audits, CySEC fees, compliance reporting.",
                            },
                            {
                                name: "Capital Requirement",
                                description: "€50,000–€750,000 depending on tier",
                            },
                        ]}
                        end='Costs vary by jurisdiction, license type, and compliance obligations.'
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Experts in CySEC CASP registration."
                                },
                                {
                                    text: "End-to-end service: company setup, application, compliance, AML systems."
                                },
                                {
                                    text: "Partnerships with crypto-friendly banks, EMIs, and PSPs."
                                },
                                {
                                    text: "Technical integrations for wallets, exchanges, and tokenization platforms."
                                },
                                {
                                    text: "Clear comparisons: Cyprus vs Lithuania vs Estonia vs Offshore options."
                                }
                            ]
                        }
                        />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA
                        title="Looking to launch a regulated crypto business in the EU?"
                        description="Cyprus offers CASP registration under CySEC, giving your firm EU credibility, banking access, and MiCA-readiness."
                        buttonText="Book a Cyprus Crypto Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is Cyprus good for crypto exchanges?",
        content: [
            { type: "answer", text: "Yes — many exchanges register in Cyprus due to EU credibility and low tax." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "€50k–€750k depending on services (exchange, custody, market-making)." },
        ],
    },
    {
        question: "Does Cyprus CASP allow token issuance?",
        content: [
            { type: "answer", text: "Yes — ICOs, STOs, and token platforms are allowed under compliance." },
        ],
    },
    {
        question: "How long does registration take?",
        content: [
            { type: "answer", text: "6–9 months on average." },
        ],
    },
    {
        question: "How does Cyprus compare to Lithuania or Estonia?",
        content: [
            { type: "answer", text: "Cyprus is slightly stricter, but offers stronger credibility and better banking access." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We registered our crypto exchange in Cyprus. Offshore Advisory handled CySEC filing and helped us secure banking.",
            author: "Alex P.",
            role: "Exchange CEO"
        },
        {
            quote: "Cyprus was the perfect balance between cost and EU credibility. Offshore Advisory guided us through CASP registration.",
            author: "Sofia M.",
            role: "Blockchain Founder"
        }
    ]
;